module.exports = __webpack_public_path__ + "img/existing-template.147a180e.png";